import { Card } from '@material-ui/core';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import {
  GoogleMapComponent, CommonModal, ScreenContainer, CommonCard, CommonSelect, CommonSearch,
} from '../../CommonComponents';
import { dashboardReports, getClientCampaigns, getClientDashboardData } from '../../redux/actions/common';
import FeatureCommoingSoon from '../../CommonComponents/FeatureCommingSoon';

const dataReceived = [
  {
    id: 123, lat: 59.955413, lng: 30.337844, text: 'A id: 123', status: 0, title: 'A',
  },
  {
    id: 124, lat: 59.724, lng: 30.080, text: 'B id: 124', status: 1, title: 'B',
  },
  {
    id: 125, lat: 59.855400, lng: 30.3285, text: 'C id: 125', status: 2, title: 'C',
  },
  {
    id: 126, lat: 59.750, lng: 30.400, text: 'D id: 126', status: 3, title: 'D',
  },
]

const dataLabels = [
  {
    id: 0, labelText: 'All Locations', status: 0, color: 'primary',
  },
  {
    id: 1, labelText: 'Verified Locations', status: 1, color: 'secondary',
  },
  {
    id: 2, labelText: 'Pending Locations', status: 2, color: 'primary',
  },
  {
    id: 3, labelText: 'Rejected Locations', status: 3, color: 'primary',
  },
]

const initialCenter = [59.838043, 30.337157]

const Dashboard = ({
  fetchDashboard, campaigns, fetchCampaigns, fetchClientDashboardData, clientDashboardData,
}) => {
  const [mapArray, setMapArray] = useState([]);
  const [mapArrayToView, setMapArrayToView] = useState([]);
  const [center, setCenter] = useState(initialCenter)
  const [zoom] = useState(9);
  const [labels, setLabels] = useState([])
  const [currentSite, setCurrentSite] = useState(null)
  const [filter, setFilter] = useState('month')
  const [filterCampaigns, setFilterCampaigns] = useState(null)
  // const [time, setTime] = useState('month')
  const user = JSON.parse(localStorage.getItem('user'))

  const handleSearch = (ev, val, reason) => {
    if (reason === 'select-option') {
      setMapArrayToView([val])
      setCenter([val.lat, val.lng])
    }
    if (reason === 'clear') {
      setMapArrayToView(mapArray)
      setCenter(initialCenter)
    }
  }

  const clearSearch = () => {
    setMapArrayToView(mapArray)
    setCenter(initialCenter)
  }

  const handleVerification = (key) => {
    setCurrentSite(key);
  }

  const handleAccept = () => {
    setCurrentSite(null)
  }

  const handleReject = () => {
    setCurrentSite(null)
  }

  useEffect(() => {
    fetchDashboard('all');
    setMapArrayToView(dataReceived)
    setMapArray(dataReceived)
    setLabels(dataLabels)
  }, [fetchDashboard])

  const handleLabelClick = (id) => {
    let markersToDisplay = mapArray.filter((item) => item.status === id)
    if (id === 0) { markersToDisplay = mapArray }
    setMapArrayToView(markersToDisplay)
  }

  const handleChangeFilter = (val) => {
    setFilter(val)
    if (user?.userType !== 'client') fetchDashboard(val);
  }

  useEffect(() => {
    const userdata = JSON.parse(localStorage.getItem('user'))
    if (userdata && userdata?.userType === 'client') fetchCampaigns()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchCampaigns])

  const handleCampaignsFilter1 = (val) => {
    setFilterCampaigns(val)
  }

  const options = [
    { text: 'All', value: 'all' },
    { text: 'This Month', value: 'month' },
    { text: 'This Week', value: 'week' },
  ]

  useEffect(() => {
    if (campaigns?.length) {
      handleCampaignsFilter1(
        campaigns[0],
      )
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaigns])

  useEffect(() => {
    if (filterCampaigns?.value && filter) {
      fetchClientDashboardData({ campaignNo: filterCampaigns?.value, time: filter });
    }
  }, [fetchClientDashboardData, filterCampaigns, filter])

  // const {
  //   approved, delayed, rejected, reported,
  // } = dashboardData

  // eslint-disable-next-line no-nested-ternary
  const desc = (filter === 'week'
    ? 'This Week' : (
      filter === 'month'
        ? 'This Month' : 'Overall'))
  return (
    <ScreenContainer title="Dashboard">
      <div className="row">

        {user?.userType === 'client' ? (
          <>
            <div className="col-3">
              <CommonSearch label="Filter 1" value={filterCampaigns} data={campaigns} onChange={handleCampaignsFilter1} />
            </div>
            <div className="col-3">
              <CommonSelect label="Filter 2" selectedValue={filter} options={options} handleChange={handleChangeFilter} />
            </div>
          </>
        ) : (
          <div className="col-3">
            <CommonSelect label="Filter By" options={options} handleChange={handleChangeFilter} />
          </div>
)}

      </div>
      <br />
      <div className="row">
        <div className="col-3">
          <CommonCard
            title="Total Reported Sites"
            label={desc}
            // change="24%"
            // description="since last week"
            stat={clientDashboardData.reportedSites}
            changeType="positive"
          />
        </div>
        {user?.userType === 'client' ? (
          <>
            <div className="col-3">
              <CommonCard
                title="State"
                label={desc}
                stat={clientDashboardData.states}
                changeType="negative"
              />
            </div>
            <div className="col-3">
              <CommonCard
                title="City"
                label={desc}
                stat={clientDashboardData.city}
              />
            </div>
          </>
       ) : (
         <>
           <div className="col-3">
             <CommonCard
               title="Rejected Sites"
               label={desc}
           // change="24%"
           // description="since last week"
               stat={0}
               changeType="negative"
             />
           </div>
           <div className="col-3">
             <CommonCard
               title="Verified Reports"
               label={desc}
               stat={0}
             />
           </div>
           <div className="col-3">
             <CommonCard
               title="Delayed Reports"
               label={desc}
           // change="0"
           // description="since last week"
               stat={0}
             />
           </div>
         </>
       )}
      </div>
      <br />
      <Card className="position-relative">
        <GoogleMapComponent
          mapData={mapArrayToView}
          data={mapArray}
          center={center}
          zoom={zoom}
          handleSearch={handleSearch}
          labels={labels}
          handleVerification={handleVerification}
          handleLabelClick={handleLabelClick}
          clearSearch={clearSearch}
        />
        <FeatureCommoingSoon />
      </Card>
      {currentSite
        ? (
          <CommonModal
            open
            onYes={handleAccept}
            onClose={handleReject}
            successButtonText="Accept"
            cancelButtonText="Reject"
            width="lg"
          >
            <pre>
              {JSON.stringify(mapArray.find((item) => item.id === parseInt(currentSite, 10)))}
            </pre>
          </CommonModal>
        )
        : null}
    </ScreenContainer>
  )
};

const mapState = (state) => ({
  dashboardData: state.common.dashboardReports,
  campaigns: state.common.clientsCampaigns,
  clientDashboardData: state.common.clientDashboardData,

});

const mapActions = {
  fetchDashboard: dashboardReports,
  fetchCampaigns: getClientCampaigns,
  fetchClientDashboardData: getClientDashboardData,
};

export default connect(mapState, mapActions)(Dashboard);
